import React, {useState} from 'react';

const MessagesContext = React.createContext({});

const MessagesProvider = (props) => {
    const [store, setStore] = useState({
        ...props,
    });

    const [actions] = useState({
        setConversationMessages: (updatedMessages) => {
            setStore({...store, messages: updatedMessages});
        },
    });

    return <MessagesContext.Provider value={{store, actions}} {...props} />;
};

export const MessagesConsumer = MessagesContext.Consumer;

export {MessagesContext, MessagesProvider};
